var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import styled from 'styled-components';
import { colors, cssThemedValue } from '@creditornot/cb-ingredients';
import DatePickerBase, { colorCssVars as baseColors } from './DatePickerBase';
var StyledDatePickerBase = styled(DatePickerBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .rdp-day_range_start {\n    border-start-end-radius: 0;\n    border-end-end-radius: 0;\n  }\n\n  .rdp-day_range_end:not(.rdp-day_range_start) {\n    border-start-start-radius: 0;\n    border-end-start-radius: 0;\n  }\n\n  .rdp-day_selected.rdp-day_outside {\n    &.rdp-day_range_start,\n    &.rdp-day_range_end {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n\n  .rdp-day_selected.rdp-day_range_middle {\n    border-radius: 0;\n\n    &:not(.rdp-day_outside) {\n      background-color: ", ";\n      color: ", ";\n\n      &:not(.rdp-day_disabled):hover {\n        background-color: ", ";\n      }\n    }\n\n    &.rdp-day_outside {\n      background-color: ", ";\n    }\n  }\n"], ["\n  .rdp-day_range_start {\n    border-start-end-radius: 0;\n    border-end-end-radius: 0;\n  }\n\n  .rdp-day_range_end:not(.rdp-day_range_start) {\n    border-start-start-radius: 0;\n    border-end-start-radius: 0;\n  }\n\n  .rdp-day_selected.rdp-day_outside {\n    &.rdp-day_range_start,\n    &.rdp-day_range_end {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n\n  .rdp-day_selected.rdp-day_range_middle {\n    border-radius: 0;\n\n    &:not(.rdp-day_outside) {\n      background-color: ", ";\n      color: ", ";\n\n      &:not(.rdp-day_disabled):hover {\n        background-color: ", ";\n      }\n    }\n\n    &.rdp-day_outside {\n      background-color: ", ";\n    }\n  }\n"])), cssThemedValue('textSecondary'), baseColors.dayTextSelected, colors.wolt8, colors.wolt100, colors.wolt16, baseColors.outsideDayBgSelected);
/**
 * Date picker to select a range of dates
 */
var DateRangePicker = function (_a) {
    var onChange = _a.onChange, onDayClick = _a.onDayClick, _b = _a.value, value = _b === void 0 ? {} : _b, rest = __rest(_a, ["onChange", "onDayClick", "value"]);
    var _c = __read(useState(), 2), lastSelection = _c[0], setLastSelection = _c[1];
    var from = value.from, to = value.to;
    return (React.createElement(StyledDatePickerBase, __assign({}, rest, { initialMonth: value.from || value.to, mode: "range", onDayClick: function (day) {
            if (onDayClick) {
                onDayClick(day);
            }
            if (!onChange) {
                return;
            }
            // selecting 'from'
            if (!from || lastSelection === undefined || lastSelection === 'to') {
                setLastSelection('from');
                return onChange({
                    from: day,
                    to: to && to >= day ? to : undefined,
                });
            }
            if (from && day < from) {
                setLastSelection('to');
                return onChange({ from: day, to: from });
            }
            if (from && day >= from) {
                setLastSelection('to');
                return onChange({ from: from, to: day });
            }
        }, selectedDays: value })));
};
export default DateRangePicker;
var templateObject_1;
//# sourceMappingURL=DateRangePicker.js.map